// Pure helper: ISO-8601 timestamp → relative human-readable string (deutsch).
//
// Schwellen:
//   diff < 60s     → "eben"
//   diff < 60min   → "vor X min"
//   diff < 24h     → "vor X h"
//   diff < 7d      → "vor X T"
//   diff ≥ 7d      → toLocaleDateString('de-DE') (z.B. "06.05.2026")
//
// Future-dates (negative diff) defensiv → "eben" (sec < 60 trifft).
//
// Extrahiert aus AssetCard.tsx (vorher inline) — wird jetzt 2× genutzt
// (AssetCard 3rd line + LibraryPage Header-Stats lastUpload).
//
// `now` optional für deterministic tests (default Date.now()).
export function formatRelative(iso: string, now = Date.now()): string {
  const diff = now - new Date(iso).getTime();
  const sec = Math.floor(diff / 1000);
  if (sec < 60) return 'eben';
  const min = Math.floor(sec / 60);
  if (min < 60) return `vor ${min} min`;
  const h = Math.floor(min / 60);
  if (h < 24) return `vor ${h} h`;
  const d = Math.floor(h / 24);
  if (d < 7) return `vor ${d} T`;
  // Locale-Date — deterministic für tests via toLocaleDateString('de-DE').
  return new Date(iso).toLocaleDateString('de-DE');
}
